module.exports = __webpack_public_path__ + "static/favicon-a5f4269bf4edf671fcbc5c88517e98f7.ico";